import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@repo/ui'
import StationDarkSvg from './StationDarkSvg'

export default function PageNotFound() {
  const navigate = useNavigate()
  const { t } = useTranslation('errorpage')
  const testIdInit = 'page-not-found'

  const gotoBfnOverview = () => {
    navigate('/')
  }

  return (
    <div className="text-center">
      <div className="flex-1 transform scale-140 my-4 justify-center items-center mx-auto">
        <StationDarkSvg />
      </div>
      <p className="my-1" data-testid={`${testIdInit}-text`}>
        {t('sub_text')}
      </p>
      <Button
        className="mt-1"
        onClick={gotoBfnOverview}
        data-testid={`${testIdInit}-button`}
      >
        {t('to_bfn_button')}
      </Button>
    </div>
  )
}
